exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".humanizacion[data-v-07eea496]{display:none;height:34px;justify-content:center;align-items:center;width:100%;z-index:1000;font-size:13px;box-shadow:0 -3px 8px -1px hsla(0,0%,47%,.12);background-color:#fff;border-radius:0 0 12px 12px;color:#787878;bottom:0;position:absolute}.texTyping[data-v-07eea496]{width:fit-content;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-07eea496","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ContentHumanizacion.vue
// module id = 173
// module chunks = 0 1